import { render, staticRenderFns } from "./ZRole.vue?vue&type=template&id=6db54c97&scoped=true"
import script from "./ZRole.vue?vue&type=script&lang=js"
export * from "./ZRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db54c97",
  null
  
)

export default component.exports